import { useCallback, useEffect, useState } from 'react'

const TWENTY_FOUR_HOURS_IN_MS = 24 * 60 * 60 * 1000

export const useModal = (defaultOpen = false) => {
  const [hasHydrated, setHasHydrated] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false)

  const openModal = useCallback(() => setIsModalOpen(true), [])
  const closeModal = useCallback(() => {
    setIsModalOpen(false)
    if (typeof window !== 'undefined') {
      localStorage.setItem('modalClosedAt', `${Date.now()}`)
    }
  }, [])

  const toggleModal = useCallback(() => setIsModalOpen(prev => !prev), [])

  useEffect(() => {
    if (typeof window === 'undefined') return

    setHasHydrated(true)

    if (!defaultOpen) return

    const now = Date.now()
    const closedAt = localStorage.getItem('modalClosedAt')

    if (closedAt && now - parseInt(closedAt, 10) < TWENTY_FOUR_HOURS_IN_MS) {
      // User recently closed modal
      return
    }

    // Clear timestamp and open after delay
    localStorage.removeItem('modalClosedAt')

    const timer = setTimeout(() => {
      setIsModalOpen(true)
    }, 2000)

    return () => clearTimeout(timer)
  }, [defaultOpen])

  return {
    isModalOpen: hasHydrated ? isModalOpen : false,
    openModal,
    closeModal,
    toggleModal,
    setIsModalOpen
  }
}
